var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.36554C13.6441 7.54482 10.3559 7.54482 8 9.36554",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66797 11.7957C11.0425 10.7348 12.9597 10.7348 14.3342 11.7957",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58582 19L11.2929 20.7071C11.6834 21.0976 12.3166 21.0976 12.7071 20.7071L14.4142 19H18C19.6569 19 21 17.6569 21 16V6C21 4.34315 19.6569 3 18 3H6C4.34315 3 3 4.34315 3 6V16C3 17.6569 4.34315 19 6 19H9.58582Z",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 14.25C12.0695 14.2503 12.1252 14.3063 12.125 14.3753C12.1248 14.4443 12.0688 14.5001 11.9998 14.5C11.9309 14.4999 11.875 14.444 11.875 14.375C11.8748 14.3417 11.888 14.3097 11.9116 14.2862C11.9352 14.2628 11.9672 14.2497 12.0005 14.25",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.17ab57b7c2fe60095b235bb73838cbc6.svg";
export { ForwardRef as ReactComponent };